export { RadioBadgeGroupComponent } from './radio-badge-group.component';
